<template>
    <div>
        <div></div>
        <v-card flat>
            <v-card-text>
                This is a homegrown component that is a fully-fledged wrapper around the <a href="https://vuetifyjs.com/en/components/data-tables/" target="_blank"><code>&lt;v-data-table&gt;</code> Vuetify component</a><br/>
                Since it's a full wrapper, that means we can utilize slots that Vuetify already had baked-in.<br/>
                Any props that it would normally accept can still be used as well. Some of them we might intercept of
                course.<br/>
                Event propagation should still work also.<br/>
            </v-card-text>
        </v-card>
        <v-card flat>
            <v-card-text>
                Where it really shines is its flexibility though.
                You can pass it <code>:items</code> as a prop, and it will work with the data you are feeding it.
                <smart-table
                    :headers="headers"
                    :items="features"
                >
                </smart-table>
            </v-card-text>
        </v-card>
        <v-card flat>
            <v-card-text>
                Alternatively, you can omit <code>:items</code>, and specify an <code>:endpoint</code> instead.  It will fetch data from there.
                <smart-table
                    :headers="headers"
                    endpoint="examplefiles.list"
                >
                </smart-table>
            </v-card-text>
        </v-card>
    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "ExampleSmartTable",
    components: {
        AppLayout,
        SmartTable
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            examplefile: this.input,
            features:[
                {name:'Paging', description:'Got more data than can fit on one page?'},
                {name:'Sorting', description:'Choose a column -- or columns to sort by!'},
                {name:'Searching', description:'Global text can be used to search across multiple columns'},
                {name:'Filtering', description:'Filters defined within the headers can make it easy to find a specific value in a specific column'},
                {name:'Remote fetching', description:'Can fetch data from a backend server'},
            ],
            filters: {
                name: undefined,
                description: undefined
            },
        }
    },
    computed: {
        headers() {
            // These get defined as computed props.  This is important especially for the values that get injected into the per-column searches
            return [
                {value: 'name',         text: 'Name',           align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.name  },
                {value: 'description',  text: 'Description',    align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.description  },
            ]
        },
    },
    methods: {
        doSomething() {
            console.log(this.examplefile)
        },
    },
}
</script>

<style>

</style>
